'use client';

import { AccountAdmin } from '@api/models';
import { useQuery } from '@tanstack/react-query';

import { BrowserApiClient } from '@website/lib/api/browser';

/**
 * Unified admin accounts list: every user with professional fields layered on
 * server-side (GET /admin/accounts). One purpose-built query replaces the two
 * full-table sweeps (users + professionals) the accounts page used to merge
 * client-side.
 *
 * Fetches all pages; search/filtering stays client-side on the cached list.
 */
export function useAccountsAdmin() {
  return useQuery({
    queryKey: ['accounts-admin'],
    queryFn: async () => {
      const allAccounts: AccountAdmin[] = [];
      let cursor: string | undefined;

      do {
        const result = await BrowserApiClient.getAccountsAdmin({ cursor });
        allAccounts.push(...result.data);
        cursor = result.cursor ?? undefined;
      } while (cursor);

      return allAccounts;
    },
    staleTime: 60 * 1000,
    retry: 2
  });
}
